import { useFragment } from "@apollo/client";
import { EXPERIMENT_FRAGMENT } from "@shared/graphql.fragments";

import type { ExperimentType } from "@shared/graphql.types";

type ExperimentUpSell = {
  isControl: boolean;
  isPrimary: boolean;
  isSecondary: boolean;
  isTertiary: boolean;
};

export function useMembershipUpSellFragment(): ExperimentType {
  const { data } = useFragment<ExperimentType>({
    fragment: EXPERIMENT_FRAGMENT,
    fragmentName: "ExperimentFragment",
    from: {
      __typename: "ExperimentType",
      id: "experiment-basket-membership-upsell"
    }
  });

  return data as ExperimentType;
}

export function useMembershipUpSellExperiment(): ExperimentUpSell {
  const data = useMembershipUpSellFragment();

  const { metadata = {} } = data;
  const { value } = metadata;

  return {
    isControl: ["control", "throwaway"].includes(value),
    isPrimary: ["variant-1", "variant-1-throwaway"].includes(value),
    isSecondary: ["variant-2", "variant-2-throwaway"].includes(value),
    isTertiary: ["variant-3", "variant-3-throwaway"].includes(value)
  };
}
